import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { publicApi } from "@/lib/api";

const DISMISS = "zap_push_dismissed";
const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const toKey = (b64) => {
  const s = (b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
};

async function subscribe() {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await publicApi.get("/public/push/key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) });
  }
  await publicApi.post("/public/push/subscribe", { subscription: sub.toJSON() });
}

export const PushPrompt = ({ me }) => {
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    if (!me) return;
    if (!supported()) {
      if (isIOS() && !standalone() && !localStorage.getItem(DISMISS)) { setMsg("ios"); setShow(true); }
      return;
    }
    if (Notification.permission === "granted") { subscribe().catch(() => {}); return; }
    if (Notification.permission === "default" && !localStorage.getItem(DISMISS)) setShow(true);
  }, [me]);
  if (!show) return null;
  const dismiss = () => { localStorage.setItem(DISMISS, "1"); setShow(false); };
  const enable = async () => {
    const perm = await Notification.requestPermission();
    if (perm === "granted") {
      try { await subscribe(); toast.success("Avisos ativados."); } catch (e) { toast.error("Não foi possível ativar os avisos neste aparelho."); }
      setShow(false);
    } else dismiss();
  };
  return (
    <div data-testid="push-prompt" className="flex shrink-0 items-center gap-3 border-b border-[#C9A24A]/40 bg-zap-goldsoft px-4 py-2 sm:px-6">
      <BellRing className="h-5 w-5 shrink-0 text-zap-deep" />
      <p className="min-w-0 flex-1 text-[15px] leading-snug text-zap-ink">
        {msg === "ios" ? "Para receber avisos no iPhone, toque em Instalar e abra o ZAP IUDP pela tela inicial." : "Quer receber um aviso no celular quando a igreja enviar mensagem?"}
      </p>
      {msg !== "ios" && <button data-testid="push-enable" onClick={enable} className="h-10 shrink-0 rounded-full bg-zap-deep px-4 text-sm font-bold text-white">Ativar avisos</button>}
      <button data-testid="push-dismiss" onClick={dismiss} aria-label="Agora não" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-black/5"><X className="h-5 w-5" /></button>
    </div>
  );
};
